import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import path from "../path";

export default function RingMesh(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(path + "/assets/ring.glb");
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        // castShadow
        // receiveShadow
        geometry={nodes.Cylinder001.geometry}
        // material={nodes.Cylinder002.material}
        position={[0, 0, 0]}
      >
        {props.children || (
          <meshStandardMaterial
            attach="material"
            color={"blue"}
            side={THREE.DoubleSide}
          />
        )}
      </mesh>
    </group>
  );
}

useGLTF.preload(path + "/assets/ring.glb");
